import {
    Component,
    Input,
    ContentChildren,
    QueryList,
    AfterViewInit,
    ElementRef,
    ViewChild,
    Output,
    EventEmitter,
    SimpleChanges
} from '@angular/core';
import { Router } from '@angular/router';

type OnTabChangeCallback = (tab: ITrTab) => any;
interface ITrTab {
    id: number;
    link?: string;
    label: string;
    element: HTMLDivElement;
}

@Component({
    selector: 'tr-tabs',
    styleUrls: ['./tr-tabs.component.scss'],
    templateUrl: './tr-tabs.component.html',
})
export class TrTabsComponent implements AfterViewInit {

    @Input()
    public selectedTabId: number = 0;

    @Input()
    public isContained: boolean = false;

    @Input()
    public hideListWhenOne: boolean = false;

    @Input()
    public tabChange: OnTabChangeCallback;

    @Output()
    public selectedTabIdChange: EventEmitter<number> = new EventEmitter();

    public tabs: ITrTab[] = [];

    @ContentChildren('tab')
    private tabElements: QueryList<ElementRef<HTMLDivElement>>;

    @ViewChild('selectedTab', { static: true })
    private selectedTabContent: ElementRef<HTMLDivElement>;

    public constructor(private router: Router) { }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedTabId && this.tabs.length) {
            const { currentValue, previousValue } = changes.selectedTabId;

            if (currentValue != previousValue) {
                this.changeTab(currentValue);
            }
        }
    }

    public ngAfterViewInit() {

        this.tabElements.forEach(({ nativeElement: tab }, id) => {
            this.tabs.push({
                id,
                link: tab.getAttribute('link'),
                label: tab.getAttribute('label') || `Tab ${id + 1}`,
                get element() { return tab; },
            });
        });

        this.appendTabContent(this.tabs[this.selectedTabId || 0]);
    }

    public changeTab(id: number) {
        const tab = this.tabs[id];
        if (tab) {
            this.appendTabContent(tab);
    
            if (tab.link) {
                this.router.navigate([tab.link]);
            }
    
            this.selectedTabIdChange.emit(this.selectedTabId = tab.id);
    
            if (typeof this.tabChange === 'function') {
                this.tabChange(tab);
            }
        }
    }

    private appendTabContent(tab: ITrTab) {
        const currentTab = this.selectedTabContent.nativeElement.childNodes.item(0);

        if (currentTab) {
            this.selectedTabContent.nativeElement.removeChild(currentTab);
        }

        this.selectedTabContent.nativeElement.appendChild(tab.element);
    }
}
